import { render, staticRenderFns } from "./pricing-v1.vue?vue&type=template&id=7d1bdb3e&scoped=true"
import script from "./pricing-v1.vue?vue&type=script&lang=js"
export * from "./pricing-v1.vue?vue&type=script&lang=js"
import style0 from "./pricing-v1.vue?vue&type=style&index=0&id=7d1bdb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1bdb3e",
  null
  
)

export default component.exports